'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: content-box;\n  display: inline-flex;\n  position: relative;\n  transition-delay: 150ms;\n  transition: margin ease 300ms;\n  flex-shrink:0;\n\n  &:not(:only-of-type) {\n    display: inline-flex;\n  }\n\n  &:not(:only-of-type),\n  & ~ &:not(:first-of-type) {\n    margin-', ': ', 'px;\n  }\n\n  &:last-of-type {\n    ', '\n  }\n'], ['\n  box-sizing: content-box;\n  display: inline-flex;\n  position: relative;\n  transition-delay: 150ms;\n  transition: margin ease 300ms;\n  flex-shrink:0;\n\n  &:not(:only-of-type) {\n    display: inline-flex;\n  }\n\n  &:not(:only-of-type),\n  & ~ &:not(:first-of-type) {\n    margin-', ': ', 'px;\n  }\n\n  &:last-of-type {\n    ', '\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

exports.default = (0, _styledComponents2.default)('div').withConfig({
  displayName: 'AvatarWrapper'
})(_templateObject, function (props) {
  return props._isListReversed ? 'left' : 'right';
}, function (props) {
  return -1 * props.overlapOffset;
}, function (props) {
  return props._isListReversed && 'margin-left: 0 !important;';
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.493/js/UIAvatarDisplay/baseStyledComponents/AvatarWrapper.js
// module id = 488
// module chunks = 2 3